module.exports = __webpack_public_path__ + "images/logo-light-502b9a2f53825747c46d14c013b6f727.png";